import { Component, OnInit } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { TokenManager } from '../Globals';

@Component({
  selector: 'app-layout-profile-detail',
  templateUrl: './layout-profile-detail.component.html',
  styleUrls: ['./layout-profile-detail.component.css']
})
export class LayoutProfileDetailComponent implements OnInit {

  isProfile : boolean = true;
  selectedDetailId: string;
  private componentId: string;
  private searchKeyword : string = "";
  private smallPad: boolean = false;
  constructor(private route:ActivatedRoute, 
    private router:Router, 
    public globals: Globals,
    private summaryService:SummaryService,
    private tokenManager:TokenManager) { }

  ngOnInit() {
    this.tokenManager.store("BRNCurrentRoute", this.router.url);
    if(this.globals.Session == null){this.router.navigate(['/', '/']) };
    if(this.route.snapshot.paramMap.get('id')){
      this.selectedDetailId = this.route.snapshot.paramMap.get('id');
    }

    // if(this.componentId && this.globals.Session){
    //   this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(result=>{
    //     if(result){
    //       this.searchKeyword = result;
    //     }else{
    //       this.searchKeyword = "";
    //     }
    //   })
    // }
  }

  toggleSidebar(showView : boolean) {
    if (showView){
      this.smallPad = false;
    }
    else{
      this.smallPad = true;
    }
  }

}
